import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApiService from "@/api/ApiService";
Vue.use(VueAxios, axios)
export const PeopleManagerService = {
  baseURL: process.env.VUE_APP_PEOPLE_MANAGER_URL,

  getPeople(params) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/people`, '', params)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  createPerson(params) {
    return ApiService.post(`${this.baseURL}/v1/people`, params)
    /*return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v1/people`, params)
      .then(response => resolve(response.data))
      .catch(err => {
        console.log("HERE")
          reject(err)
      }

      )
    })*/
  },
  updatePerson(personId, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/people/${personId}`, params)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getPatient(id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/people/${id}`, '')
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getDistritos() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/distritos/all`, '')
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  resyncPerson(personId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/sifarma/retrySync?peopleManagerPersonId=${personId}`,)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }

}


